import { MessageOutlined } from "@ant-design/icons";
import { Badge, Col, Divider, Image, List, Row, Tag, Tooltip, Typography } from "antd";

import LazyLoadImage from "apps/Common/LazyLoadImage";
import { getRelativeDate } from "helpers/getRelativeDate";
import { setBackEndUlr } from "helpers/SetBackEndUrl";
import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "store/Reducers";
import { handleSetMessageDetailsFilter } from "../../ClientSideStates";
import TruncatedText from "apps/Common/TruncatedText";

const UserMessageItem: FC<{ item: any }> = ({ item }) => {
  const { Text } = Typography;
  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const { messageDetilsFilter } = useSelector(
    (state: RootState) => state.message
  );
  const handleSetUserName = () => {
    if (userInfoes?.id === item.advertUserId) {
      return item.contactPerson;
    } else {
      return item.advertPerson;
    }
  };



  const dispatch = useDispatch();
  return (
    <Col xs={24} className="!p-0" >
      <List.Item

        className="hover:cursor-pointer !p-0"
        onClick={() => {
          let advertId = item.advertId;
          let contactUserid = item.contactUserId;
          const allFilter = {
            ...messageDetilsFilter,
            AdvertId: advertId,
            ContactUserId: contactUserid,
          };

          dispatch(handleSetMessageDetailsFilter({ filter: allFilter }));
        }}
      >
        <Row className="!w-full " gutter={[0, 20]}>
          <Col xs={24} className="!flex gap-4 !w-full  ">

            <LazyLoadImage

              src={setBackEndUlr() + "/" + item?.advertMainImage}
              alt=""
              wrapperWidth="100px"
              wrapperHeight="80px"
              classNames="!flex justify-center items-center !border !border-gray-200 !rounded-sm !p-1"

              imageClassName="!rounded-xl"
              style={{ objectFit: "contain" }}
            />

            <div className="!flex items-center gap-2 justify-between !w-full">
              <div className="!grid gap-2">
                <div className="!flex ">
                  <Text className="!font-bold md:!text-[17px] !text-sm !text-black">
                    {`${handleSetUserName()}`}
                  </Text>
                </div>
                <TruncatedText
                  wrapperClassName="flex"
                  textClassName="!text-black"
                  maxLines={1}
                  title={item?.advertTitle}

                />

                <div className="!flex">
                  <Tag color="#ffc600" className="!text-black">
                    {getRelativeDate(item.lastMessageDate)}
                  </Tag>
                </div>
              </div>
              <div>
                <Badge
                  count={item.unreadMessageCount}
                  color="#00a884"
                  offset={[0, -10]}
                >
                  <MessageOutlined className="!text-lg !text-black" />
                </Badge>
              </div>
            </div>
          </Col>
          <Col xs={24} >
            <Divider className="!m-0" />
          </Col>
        </Row>
      </List.Item>

    </Col>
  );
};

export default UserMessageItem;
